import { render, staticRenderFns } from "./StationDetailsSlider.vue?vue&type=template&id=2d6919b5&scoped=true"
import script from "./StationDetailsSlider.vue?vue&type=script&lang=js"
export * from "./StationDetailsSlider.vue?vue&type=script&lang=js"
import style0 from "./StationDetailsSlider.vue?vue&type=style&index=0&id=2d6919b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6919b5",
  null
  
)

export default component.exports